
import Vue from 'vue'
import {searchEnergyEquipList} from '@/api/common'
export default Vue.extend({
  props: {
    value: {
      type: [Number, String],
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    placeholder: {
      type: String,
      default: '请输入设备名称',
    },
    size: {
      type: String,
      default: 'small',
    },
    // 可选值water、electric
    type: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      list: [] as Array<any>,
      loading: false,
    }
  },
  computed: {
    item: {
      set(val) {
        this.$emit('input', val)
      },
      get() {
        return this.value
      },
    },
    energy_type() {
      if (this.type === 'water') return 'energy_watermeter'
      if (this.type === 'electric') return 'energy_electricmeter'
      return ''
    },
  },
  methods: {
    async filter(keyword: string) {
      if (keyword !== '') {
        this.loading = true
        const data = await searchEnergyEquipList({keyword, energy_type: this.energy_type})
        this.list = Object.keys(data).length ? data : []
        this.loading = false
      } else {
        this.list = []
      }
    },
    select(id: any) {
      const item = this.list.find(e => e.id === id)
      this.$emit('change', id, item)
    },
    focus(e: FocusEvent) {
      !(e.target as HTMLInputElement).value && (this.list = [])
    },
  },
})
